import { ExamContextHandler } from 'Core/ContextHandler/ExamContextHandler'
import { ActionConfig, ActionContext, IAction } from '../Action'
import { ContainerType } from 'Types/Tasks.types'

export class SubmitAttributeAction implements IAction {
    static Id = 'SubmitAttribute' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.addAction(
            {
                id: 'submit-attributes',
                title: this.config?.title ?? 'Submit',
                type: 'button',
                onClick:
                    this.config?.onClick ??
                    (async () => {
                        const canSubmit = await this.actionContext.task.validateData()
                        if (!canSubmit) {
                            return
                        }
                        const errors =
                            this.actionContext.studio.inputManager.getViolationCount('error')
                        if (errors > 0) {
                            return
                        }
                        ;(
                            this.actionContext.task.contextHandler as ExamContextHandler<
                                ContainerType,
                                unknown
                            >
                        ).submitAttributes()
                    }),
                color: 'primary',
                disabled: this.config?.disabled ?? false,
                tooltip: this.config?.tooltip,
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor.toolbar.removeAction('submit-attributes')
    }
}
